<template>
  <div class="factory-access-dashboard-layout">
    <!-- -->
    <vx-card>
      <div>
        <slot></slot>
      </div>
    </vx-card>

    <!-- 상세정보 -->
    <vx-card>
      <div>
        <slot name="right"></slot>
      </div>
    </vx-card>

  </div>
</template>

<script>
export default {
  name: "FactoryAccessDashboardLayout"
}
</script>

<style scoped>
.factory-access-dashboard-layout::v-deep .vx-card .vx-card__body{
  padding: 1.15rem;
}
.factory-access-dashboard-layout {
  display: grid;
  grid-template-columns: 1fr 312px;
  gap: 1rem;
}
</style>
